import URI from 'urijs';

import theme from '../themes/themes';

// TODO Přidat dokumentaci?
/* eslint-disable require-jsdoc */

function ConfigParser () {
	function getGuid (string) {
		if (string) {
			return string.split(',').map((guid) => guid.trim());
		}
		// TODO Hard-coded testovací hodnoty.
		return [
			'3FD10126-AB12-4355-A124-746C67FAB506_R',
			'3FD10126-AB12-4355-A124-746C67FAB506_A'
		];
	}

	function getHeader (header) {
		if (!header) {
			return [{leftText: '', rightText: ''}, {leftText: '', rightText: ''}];
		}
		return header.split(',').map((d) => d.trim()).reduce((acc, item) => {
			const names = item.split('/');
			acc.push({
				leftText: names[0] || '',
				rightText: names[1] || ''
			});
			return acc;
		}, []);
	}

	function getQueues (params) {
		return params.guid.reduce((acc, item, idx) => {
			acc[item] = {
				id: params.guid[idx],
				count: params.rows[idx],
				header: {
					leftText: params.headerTitles[idx].leftText,
					rightText: params.headerTitles[idx].rightText,
					color: `#${params.headerStyle.color}`,
					size: params.headerStyle.size
				},
				arrow: {
					color: `#${params.dataStyle.rightColor}`,
					size: params.dataStyle.rightSize * 0.8
				},
				patient: {
					color: `#${params.dataStyle.leftColor}`,
					size: params.dataStyle.leftSize
				},
				door: {
					color: `#${params.dataStyle.rightColor}`,
					size: params.dataStyle.rightSize
				}
			};
			return acc;
		}, {});
	}

	function getRows (string) {
		if (string) {
			return string.split(',').map((row) => row.trim());
		}
		// TODO Hard-coded testovací / výchozí hodnoty.
		return [2, 3];
	}

	function getServerUrl (server) {
		// Kvuli zpetne kompatabilite, kdy se v kiwi-serveru zadávali dva servery,
		// aby bylo možné načítání z více front
		const defaultServer = 'http://localhost:8091/';
		if (!server) {
			return defaultServer;
		}
		const servers = server.split(',').map((d) => d.trim());
		if (servers.length <= 0) {
			return defaultServer;
		}
		const [firstServer] = servers;
		if (!firstServer.startsWith('https://') && !firstServer.startsWith('http://')) {
			return `http://${firstServer}`;
		}
		return servers[0];
	}

	function getStyle (style) {
		if (!style) {
			return null;
		}
		const s = style.toLowerCase();
		switch (s) {
		case 'white': return theme.Old.White;
		case 'blue': return theme.Old.Blue;
		case 'light': return theme.Old.Light;
		default: return style;
		}
	}

	function getPlaySound (sound) {
		if (!sound) {
			return 'gong';
		}
		switch (sound.toLowerCase()) {
		case 'gong': return 'gong';
		case 'double-gong': return 'double-gong';
		case 'bell-ringtone-4': return 'bell-ringtone-4';
		case 'friendly-ringtone': return 'friendly-ringtone';
		case 'gong-new': return 'gong-new';
		case 'xylophone-jingle-06': return 'xylophone-jingle-06';
		default:
			console.warn(`${sound} is unknown value for playSound parameter. Using default sound.`);
			return 'gong';
		}
	}

	// eslint-disable-next-line complexity
	function parseLocation (location) {
		const queryString = location.search.slice(1) || location.hash.slice(1);
		const parameters = URI(`?${queryString}`).query(true);
		const styleName = getStyle(parameters.style) || theme.Old.White;
		const guid = getGuid(parameters.guid);
		let queues = getQueues({
			guid,
			rows: getRows(parameters.rows),
			headerTitles: getHeader(parameters.header),
			headerStyle: {
				size: parameters.headerFontSize || '55',
				color: parameters['headerColor-colorPicker'] || 'ffffff'
			},
			dataStyle: {
				leftSize: parameters.leftDataFontSize || '130',
				leftColor: parameters['leftDataFontColor-colorPicker'] || 'ffffff',
				rightSize: parameters.rightDataFontSize || '130',
				rightColor: parameters['rightDataFontColor-colorPicker'] || 'ffffff'
			}
		});
		// Pokud je zvolen styl new-big, tak první řádek je povinný, číslo řádku udává počet řádků v malém zobrazení
		if (styleName === theme.New.Big) {
			queues = Object.entries(queues).reduce((acc, [key, value], idx) => {
				acc[key] = {...value, count: parseInt(value.count, 10) + 1};
				return acc;
			}, {});
		}

		const playSound = getPlaySound(parameters.playSound);

		let volume = parseInt(parameters.volume, 10);
		if (isNaN(volume)) {
			volume = 100;
		}

		let arrowStyle = parameters.arrowStyle || 'default';
		if (styleName === theme.Old.Blue || styleName === theme.Old.Light || styleName === theme.Old.White) {
			// Prepsani stylu šipky pokud bylo nastaveno staré téma, kde jiné šipky nejsou podporovány
			arrowStyle = 'default';
		}

		const popupCall = {
			enabled: parameters.popupCall === 'true' || false,
			classes: decodeURIComponent((parameters.popupCallCssStyles || '').replaceAll('+', '%20')),
			backgroundUrl: parameters.popupCallBackgroundUrl || ''
		};

		return {
			guid,
			playSound,
			volume,
			queues,
			refreshInterval: parameters.refreshInterval || 2,
			sentryDsn: parameters.sentryDsn,
			serverUrl: getServerUrl(parameters.server),
			theme: {
				backgroundUrl: parameters.backgroundUrl || '',
				name: styleName,
				arrowStyle,
				fontFamily: parameters.fontFamily || 'Open Sans',
				customRowClasses: decodeURIComponent((parameters.rowCssStyles || '').replaceAll('+', '%20')),
				popupCall
			}
		};
	}

	return Object.freeze({parseLocation});
}

export default ConfigParser;
